export const COURSE_TITLES = {
  cloud: "الحوسبة السحابية",
  cyber: "الجرائم الإلكترونية",
  hrpay: "إدارة نظم الأجور والتعويضات",
  math: "الرياضيات",
  eng1: "لغة إنجليزية 1",
  eng2: "لغة إنجليزية 2",
  eng3: "لغة إنجليزية 3",
  business: "مبادئ إدارة الأعمال",
  writing: "كتابة فنية",
  law: "مبادئ قانون",
  stats: "مقدمة في الإحصاء",
  safety_reports: "كتابة تقارير السلامة",
  safety_management: "نظام إدارة السلامة والصحة المهنية",
  accounting: "مبادئ محاسبة",
  career: "التوجيه المهني والتميز",
  admin_law: "القانون الإداري",
  islamic_law: "المدخل للفقه الإسلامي",
  criminal_law: "القانون الجزائي العام",
  family_law: "أحكام الأسرة",
  insurance_law: "أحكام الضمان",
  obligation: "مصادر الالتزام",
  commercial_law: "القانون التجاري",
  judiciary: "نظام القضاء والثبات",
  computer: "مقدمة تطبيقات الحاسب",
  advanced_computer: "تطبيقات الحاسب المتقدمة",
  hospital: "إدارة المستشفيات",
  health: "إدارة الخدمات الصحية",

  // ✅ التعديلات
  hrm: "إدارة الموارد البشرية",
  hrm_principles: "مبادئ إدارة الموارد البشرية",
  health_hrm: "إدارة الموارد البشرية الصحية",

  learning: "مهارات التعلم",
  job_analysis: "تحليل وتقييم الوظائف",
  hr_planning: "تخطيط الموارد البشرية",
  arabic_typing: "مهارات الطباعة العربية",
  english_typing: "مهارات الطباعة انجليزي",
  admin_comm: "الاتصالات الإدارية",
  office_tech: "إدارة وتقنيات المكاتب",
  safety: "مقدمة في السلامة والصحة المهنية",
  safety_law: "تشريعات السلامة والصحة المهنية",
  safety_systems: "مقدمة في أنظمة ولوائح السلامة",
  industrial_safety: "إدارة السلامة الصناعية",
  facility_safety: "متطلبات السلامة في المنشآت",
  risk_analysis: "تحليل المخرار",
  work_safety: "سلامة بيئة العمل",
  economics: "مقدمة في الاقتصاد",
  business_world1: "التعرف على عالم الأعمال 1",
  business_world2: "التعرف على عالم الأعمال 2",
  organizational: "السلوك التنظيمي",
  marketing: "مبادئ تسويق",
  finance: "الإدارة المالية",
  business_english: "لغة إنجليزية للأعمال",
  mis: "نظم المعلومات الإدارية",
  operations: "إدارة العمليات",
  e_management: "الإدارة الإلكترونية",
  quality: "إدارة الجودة الشاملة",
  strategy: "الإدارة الاستراتيجية",
  resource_management: "إدارة الموارد",
  english_reports: "إعداد التقارير الإدارية باللغة الإنجليزية",
  algorithms: "خوارزميات ومنطق",
  networking: "مبادئ شبكات الحاسب",
  programming: "أساسيات برمجة الحاسب",
  cryptography: "أساسيات علم التشفير",
  python: "البرمجة بلغة بايثون",
  programming1: "البرمجة والتحويل 1",
  cybersecurity: "أساسيات الأمن السيبراني",
  os1: "نظم التشغيل 1",
  os2: "نظم تشغيل 2",
  info_security: "إدارة أمن المعلومات",
  ethical_hacking: "الاختراق الأخلاقي",
  ai: "الذكاء الاصطناعي",
  islamic_studies: "الدراسات الإسلامية",
};